import React from "react";

export default function YTDStatement() {
    return <div>ytd-statement</div>;
}
